import { render } from "./BordereauAssurance.vue?vue&type=template&id=6e33476d&scoped=true"
import script from "./BordereauAssurance.vue?vue&type=script&lang=js"
export * from "./BordereauAssurance.vue?vue&type=script&lang=js"

import "./BordereauAssurance.vue?vue&type=style&index=0&id=6e33476d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e33476d"]])

export default __exports__